
import {SET_BOOKINGMODAL} from '../reducers/global.js';

export default function updateGlobals(action,value){
    switch(action){
        case "modal":
            return {
              'type': SET_BOOKINGMODAL,
              value
            }
        default: 
           return
    }
}